import { render, staticRenderFns } from "./PollContent.vue?vue&type=template&id=6c23cc98&scoped=true"
import script from "./PollContent.vue?vue&type=script&lang=js"
export * from "./PollContent.vue?vue&type=script&lang=js"
import style0 from "./PollContent.vue?vue&type=style&index=0&id=6c23cc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c23cc98",
  null
  
)

export default component.exports